<template>
  <a-descriptions :class="bem.b()" v-bind="attrs">
    <slot>
      <ll-descriptions-item v-for="(item, i) in list" v-bind="item" :key="i">
        <template #label>
          <slot name="label" :item="item">
            {{ item.label }}
          </slot>
        </template>
        <template #default>
          <slot name="item-content" :item="item">
            <template v-if="item.type">
              <form-component
                :ref="(el) => (formComponents[i] = el)"
                :item="item"
                :form-data="data"
              />
            </template>
            <template v-else>
              {{ data?.[item?.key] || '' }}
            </template>
          </slot>
        </template>
      </ll-descriptions-item>
    </slot>
    <!-- title描述列表的标题，显示在最顶部 -->
    <template v-if="$slots['title'] || title || titleIcon?.iconName" #title>
      <ll-icon v-if="titleIcon?.iconName" v-bind="titleIcon" />
      <slot name="title">
        <span :style="{ fontSize: `${titleSize}px`, color: titleColor }">
          {{ title }}
        </span>
      </slot>
    </template>
    <!-- title描述列表的操作区域，显示在右上方 -->
    <template v-if="$slots['extra']" #extra>
      <slot name="extra" />
    </template>
  </a-descriptions>
</template>
<script lang="ts" setup>
import { createNamespace } from '@ll-plus/utils'
import { ref, useAttrs } from 'vue'
import formComponent from '../../form/src/components/form-component.vue'
import { descriptionsProps } from './descriptions'

defineOptions({ name: 'LlDescriptions' })

defineProps(descriptionsProps)

const attrs = useAttrs()
const bem = createNamespace('descriptions')

const formComponents = ref([] as InstanceType<typeof formComponent>[])
</script>
